import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { withUIETheme } from '../uietheme/withUIETheme';
import MenuHeading from './MenuHeading';
const List = ({ children }) => {
    const style = {
        listStyle: 'none',
        margin: 0,
        padding: 0,
    };
    return (React.createElement(FelaComponent, { style: style, as: "ul" }, children));
};
const MenuGroup = ({ uieTheme, name, children }) => {
    const style = {
        paddingLeft: uieTheme.spacing.space4,
        paddingBottom: uieTheme.spacing.space3,
    };
    return (React.createElement(FelaComponent, { style: style },
        name && React.createElement(MenuHeading, null, name),
        React.createElement(List, null, children)));
};
export default withUIETheme(MenuGroup);
//# sourceMappingURL=MenuGroup.js.map